interface EnvConfig {
  firebase: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
  };
  stripe: {
    apiUrl: string;
  };
  support: {
    apiUrl: string;
  };
  appCheck: {
    recaptchaSiteKey: string;
    debugToken: string;
  };
}

function getEnvVar(key: string): string {
  const value = import.meta.env[key] as string | undefined;
  if (!value) {
    throw new Error(`Missing environment variable: ${key}`);
  }
  return value;
}

function getOptionalEnvVar(key: string, fallback: string): string {
  const value = import.meta.env[key] as string | undefined;
  return value ?? fallback;
}

export const env: EnvConfig = {
  firebase: {
    apiKey: getEnvVar('VITE_FIREBASE_API_KEY'),
    authDomain: getEnvVar('VITE_FIREBASE_AUTH_DOMAIN'),
    projectId: getEnvVar('VITE_FIREBASE_PROJECT_ID'),
    storageBucket: getEnvVar('VITE_FIREBASE_STORAGE_BUCKET'),
    messagingSenderId: getEnvVar('VITE_FIREBASE_MESSAGING_SENDER_ID'),
    appId: getEnvVar('VITE_FIREBASE_APP_ID'),
  },
  stripe: {
    apiUrl: getOptionalEnvVar('VITE_STRIPE_API_URL', ''),
  },
  support: {
    // Public Cloud Run URL — sandbox by default; staging/prod builds
    // override via the deploy workflow's env block.
    apiUrl: getOptionalEnvVar(
      'VITE_SUPPORT_API_URL',
      'https://supporttickets-zshmrdppoq-uc.a.run.app',
    ),
  },
  appCheck: {
    recaptchaSiteKey: getOptionalEnvVar('VITE_RECAPTCHA_SITE_KEY', ''),
    debugToken: getOptionalEnvVar('VITE_APPCHECK_DEBUG_TOKEN', ''),
  },
};
